export const disconnectHandler = (disconnectFunction: Function) => {
  disconnectFunction();
  localStorage.clear();
  window.dispatchEvent(new Event('local-storage-update'));
};
